export enum DocumentCheckersEnum {
  DOCUMENT_TYPE_ASSERT_EXISTS_BY_CODE = 'document/document-type-assert-exists-by-code',
  DOCUMENT_TYPE_ASSERT_EXISTS_BY_DTO = 'document/document-type-assert-exists-by-dto',
  OPERATION_TYPE_NAME_UNIQUE = 'document/operation-type-name-unique',
  OPERATION_TYPE_BRS_TASK_KIND_UNIQUE = 'document/operation-type-brs-task-kind-unique',
  OPERATION_TYPE_ASSERT_EXISTS_BY_ID = 'document/operation-type-assert-exists-by-id',
  OPERATION_TYPE_ASSERT_EXISTS_BY_DTO = 'document/operation-type-assert-exists-by-dto',
  BILL_ASSERT_EXISTS_BY_ID = 'document/bill-assert-exists-by-id',
  BILL_ASSERT_EXISTS_BY_DTO = 'document/bill-assert-exists-by-dto',
}
